import React, { useState } from 'react';
import '../../styles/AdminModal.css';
import { deleteBlogCategory } from '../../services/AdminBlogService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const BlogCategoryDeleteModal = ({ isOpen, onClose, onSuccess, category }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!category) return;

    setLoading(true);
    try {
      await deleteBlogCategory(category.id);
      onSuccess();
    } catch (error) {
      console.error('Error deleting blog category:', error);
      alert('Failed to delete blog category. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !category) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Delete Blog Category</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>

        <div className="admin__modal-body">
          <div className="delete-warning">
            <FontAwesomeIcon icon={faExclamationTriangle} className="warning-icon" />
            <p>
              Are you sure you want to delete the blog category "<strong>{category.name}</strong>"?
            </p>
            <p>This action cannot be undone.</p>
            {category.post_count > 0 && (
              <p className="warning-text">
                <strong>Warning:</strong> This category has {category.post_count} post{category.post_count > 1 ? 's' : ''}. 
                Deleting it will remove the category association from these posts.
              </p>
            )}
          </div>
        </div>

        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="button danger" onClick={handleDelete} disabled={loading}>
            {loading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogCategoryDeleteModal; 